/* ============
 * Locale
 * ============
 *
 * For a multi-language application, you can
 * specify the languages you want to use here.
 */

import en from './en_US.json';
import nl from './nl_NL.json';
import se from './sv_SE.json';

export default {
  en,
  nl,
  se,
};
